module.exports = __webpack_public_path__ + "img/tv.f1e312eb.png";